import React from "react";
import music from '../assets/music/music1.wav';

export const AudioContext = React.createContext(new Audio(music));